import { COLORS } from "@/theme"
import { ENVIRONMENT } from "@/base/environment"

export const GOOGLE_MAPS_API_KEY =
  ENVIRONMENT.googleMapsApiKey 

if (!GOOGLE_MAPS_API_KEY) {
  throw new Error("GOOGLE_MAPS_API_KEY is required")
}
export const SWATH_OUTLINE_STROKE_WEIGHT = 2

export const BASE_SWATH_FILL_OPACITY = 0.5
export const BASE_SWATH_OPTIONS: google.maps.PolygonOptions = {
  fillColor: COLORS.$reelRunSwath.fill,
  fillOpacity: BASE_SWATH_FILL_OPACITY,
  strokeColor: COLORS.$reelRunSwath.outline,
}
